export default __webpack_public_path__ + "6e56623d1b93da192bfd17912719fa06.png";